var render, staticRenderFns
import script from "./StructuralMemberLabel.vue?vue&type=script&lang=ts"
export * from "./StructuralMemberLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('227b3dac')) {
      api.createRecord('227b3dac', component.options)
    } else {
      api.reload('227b3dac', component.options)
    }
    
  }
}
component.options.__file = "src/components/Viewer/Labels/StructuralMemberLabel.vue"
export default component.exports